import { DateTimeSelector } from "@/Common/Components/Inputs/DateTimeSelector";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IDocumentCreateEditUIModel } from "@/Documents/Models/UI/IDocumentCreateEditUIModel";

interface IDocumentEditDetailsProps {
    model: IDocumentCreateEditUIModel;
    operations: DocumentEditDetailsOperations;
    disabled: boolean;
    className?: string;
}

class DocumentEditDetailsOperations {
    public SendingFacilityIdChangeOperation: number;
    public SendingFacilityReportChangeOperation: number;
    public SubClassChangeOperation: number;
    public MnemonicChangeOperation: number;
    public AuthroingDateChangeOperation: number;
    public ObservationDateChangeOperation: number;
    public HRMStatusChangeOperation: number;
    public SourceAuthorNameChangeOperation: number;

    constructor() {
        this.SendingFacilityIdChangeOperation = LocalOperations.Documents.Edit_SendingFacilityIdChange;
        this.SendingFacilityReportChangeOperation = LocalOperations.Documents.Edit_SendingFacilityReportChange;
        this.SubClassChangeOperation = LocalOperations.Documents.Edit_AccompanyingSubClassChange;
        this.MnemonicChangeOperation = LocalOperations.Documents.Edit_MnemonicChange;
        this.SourceAuthorNameChangeOperation = LocalOperations.Documents.Edit_SourceAuthorNameChange;
        this.AuthroingDateChangeOperation = LocalOperations.Documents.Edit_AuthoringDateChange;
        this.ObservationDateChangeOperation = LocalOperations.Documents.Edit_ObservationDateChange;
        this.HRMStatusChangeOperation = LocalOperations.Unassigned.Unassigned;
    }
}

class DocumentEditDetails extends React.Component<IDocumentEditDetailsProps, never> {
    public render(): JSX.Element {
        var hrmSelectionValue = this.props.model.get("SelectedHRMStatus");
        if (hrmSelectionValue == null || hrmSelectionValue == undefined)
            hrmSelectionValue = "";

        if (!this.props.model.get("AdditionalDetailsVisible")) return null;
        return (
            <div className={this.props.className} data-cy="document-edit-additionalDetails">
                <div className="row" style={{ margin: "15px 0" }}>
                    <div className="col-md-3 text-right">
                        <label className="form-label">{cacheStore.GetString("SendingFacilityIDDLabel")}</label>
                    </div>
                    <div className="col-md-9">
                        <input type="text" className="form-control" data-cy="document-edit-sendingFacilityID" disabled={this.props.disabled} value={this.props.model.get("SendingFacilityId")} onChange={e => this.onFacilityIdTextChange(e)} />
                    </div>
                </div>
                <div className="row" style={{ margin: "15px 0" }}>
                    <div className="col-md-3 text-right">
                        <label className="form-label">{cacheStore.GetString("SendingFacilitySenderFacilityReportDLabel")}</label>
                    </div>
                    <div className="col-md-9">
                        <input type="text" className="form-control" data-cy="document-edit-sendingFacilityReport" disabled={this.props.disabled} value={this.props.model.get("SendingFacilityReport")} onChange={e => this.onSenderFacilityReportTextChange(e)} />
                    </div>
                </div>
                <div className="row" style={{ margin: "15px 0" }}>
                    <div className="col-md-3 text-right">
                        <label className="form-label">{cacheStore.GetString("AccompanyingSubClassLabel")}</label>
                    </div>
                    <div className="col-md-9">
                        <input type="text" className="form-control" data-cy="document-edit-accompanyingSubClass" disabled={this.props.disabled} value={this.props.model.get("AccompanyingSubClass")} onChange={e => this.onSubClassTextChange(e)} />
                    </div>
                </div>
                <div className="row" style={{ margin: "15px 0" }}>
                    <div className="col-md-3 text-right">
                        <label className="form-label">{cacheStore.GetString("AccompanyingMnemonicLabel")}</label>
                    </div>
                    <div className="col-md-9">
                        <input type="text" className="form-control" data-cy="document-edit-accompanyingMnemonic" disabled={this.props.disabled} value={this.props.model.get("AccompanyingMnemonic")} onChange={e => this.onMnemonicTextChange(e)} />
                    </div>
                </div>
                {cacheStore.ClinicSettings.EnableDocumentSourceAuthorField && (
                    <div className="row" style={{ margin: "15px 0" }}>
                        <div className="col-md-3 text-right">
                            <label className="form-label">{cacheStore.GetString("SourceAuthorNameLabel")}</label>
                        </div>
                        <div className="col-md-9">
                            <input type="text" className="form-control" data-cy="document-edit-sourceAuthorName" disabled={this.props.disabled} value={this.props.model.get("SourceAuthorName")} onChange={e => this.onSourceAuthorNameChange(e)} maxLength={150} />
                        </div>
                    </div>
                )}

                <div className="row form-field-kendo-component" style={{ margin: "15px 0" }}>
                    <div className="col-md-3 text-right">
                        <label className="form-label">{cacheStore.GetString("AuthoringDateTimeLabel")}</label>
                    </div>
                    <div className="col-md-9">
                        <DateTimeSelector id="auth_date_time" dataCy="document-edit-authoringDateTime" cssClass="" date={this.props.model.get("AuthoringDate")} onSelectOp={this.props.operations.AuthroingDateChangeOperation} disabled={this.props.disabled} dateFormat="yyyy/MM/dd HH: mm" />
                    </div>
                </div>

                <div className="row  form-field-kendo-component" style={{ margin: "15px 0" }}>
                    <div className="col-md-3 text-right">
                        <label className="form-label">{cacheStore.GetString("ObservationDateTimeLabel")}</label>
                    </div>
                    <div className="col-md-9">
                        <DateTimeSelector id="obs_date_time" dataCy="document-edit-observationDateTime" cssClass="" date={this.props.model.get("ObservationDate")} onSelectOp={this.props.operations.ObservationDateChangeOperation} disabled={this.props.disabled} dateFormat="yyyy/MM/dd HH: mm" />
                    </div>
                </div>

                <div className="row" style={{ margin: "15px 0" }}>
                    <div className="col-md-3 text-right">
                        <label className="form-label">{cacheStore.GetString("HRMStatusDLabel")}</label>
                    </div>
                    <div className="col-md-9 ">
                        <select className="form-control myle-control" data-cy="document-edit-hRMStatus" disabled={this.props.disabled} onChange={e => this.onHRMStatusChange(e)} value={hrmSelectionValue}>
                            {this.props.model.get("HRMStatusList").toArray().sortByProperty(p => p.Value).map(r => (
                                <option key={r.Key} value={r.Key}>{r.Value}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        );
    }

    private onFacilityIdTextChange(e: React.ChangeEvent<HTMLInputElement>): void {
        var operation = new LocalEvent(this.props.operations.SendingFacilityIdChangeOperation);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
    }

    private onSenderFacilityReportTextChange(e: React.ChangeEvent<HTMLInputElement>): void {
        var operation = new LocalEvent(this.props.operations.SendingFacilityReportChangeOperation);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
    }

    private onSubClassTextChange(e: React.ChangeEvent<HTMLInputElement>): void {
        var operation = new LocalEvent(this.props.operations.SubClassChangeOperation);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
    }

    private onMnemonicTextChange(e: React.ChangeEvent<HTMLInputElement>): void {
        var operation = new LocalEvent(this.props.operations.MnemonicChangeOperation);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
    }

    private onHRMStatusChange(e: React.ChangeEvent<HTMLSelectElement>): void {
        var operation = new LocalEvent(this.props.operations.HRMStatusChangeOperation);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
    }

    private onSourceAuthorNameChange(e: React.ChangeEvent<HTMLInputElement>): void {
        const operation = new LocalEvent(this.props.operations.SourceAuthorNameChangeOperation);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { DocumentEditDetails, DocumentEditDetailsOperations };
